export default "__VITE_ASSET__D0t83jqX__"